









































import Vue from 'vue'
import { mapGetters } from 'vuex'
import QueryModal from './QueryModal.vue'
import { MAX_CHECKS_ALLOWED } from '@/config/constants'
import User from '../User/User.vue'
import Language from '../Language/Language.vue'

export default Vue.extend({
  name: 'Header',
  components: {
    QueryModal,
    User,
    Language
  },
  props: {
    previousLink: {
      type: String,
      default: '/check'
    },
    pageTitle: {
      type: String
    },
    country: {
      type: String,
      default: '-'
    },
    documentType: {
      type: String,
      default: '-'
    },
    document: {
      type: String,
      default: '-'
    }
  },
  data: () => {
    return {
      dialog: false
    }
  },
  computed: {
    ...mapGetters('results', ['getChecksCounter']),
    ...mapGetters('results', {
      headerInfo: 'getHeaderInfo'
    }),
    shownDocumentNumber () {
      if (this.headerInfo === null) {
        return this.document
      }

      return this.headerInfo.documentNumber
    },
    shownDocumentType () {
      if (this.headerInfo === null) {
        return this.documentType
      }

      return this.headerInfo.documentType
    },
    shownCountry () {
      if (this.headerInfo === null) {
        return this.country
      }

      return this.headerInfo.country
    },
    fillStyle () {
      const percentage = Math.round(this.getChecksCounter / MAX_CHECKS_ALLOWED * 100)

      if (percentage === 100) {
        return {
          width: `${percentage}%`,
          borderRadius: '1.5rem'
        }
      }

      return {
        width: `${percentage}%`
      }
    }
  }
})
